import React from "react";
import { Checkbox } from "antd";

const CustomCheckbox = ({ ...props }) => (
  <Checkbox {...props}>{props.children}</Checkbox>
);

export default CustomCheckbox;
